// import httpHubless from 'hub-http/clients/noPortalApiClient';
import http from 'hub-http/clients/apiClient';
export default class ImpersonationAPI {
  static getIsRestrictedImpersonatee() {
    return http.get(`impersonation/v1/can-edit-user`);
  }
}